// A survey keeps the tags its template had on the day it was copied, so a customer's
// previous surveys can carry tags Super Admin has since renamed or removed. The tag
// list is therefore built from the Super Admin templates only, and matching ignores
// case and stray spaces so a previous survey still shows under its tag.

const normaliseTag = tag => (tag ?? '').trim().toLowerCase()

export const isSuperAdminTemplate = survey =>
  survey.schoolId === 0 && survey.matId === 0

export function buildTemplateTags(surveys) {
  const tags = new Map()
  surveys.filter(isSuperAdminTemplate).forEach(survey =>
    survey.surveysTags?.forEach(tag => {
      const key = normaliseTag(tag)
      if (key && !tags.has(key)) tags.set(key, {tag: tag.trim()})
    })
  )
  return [...tags.values()].sort((a, b) => a.tag.localeCompare(b.tag))
}

export const hasTag = (survey, tag) =>
  survey.surveysTags?.some(x => normaliseTag(x) === normaliseTag(tag)) ?? false
